import {chainWalk, deepCopyObject} from "../../../util/Util";

export const updateConfigurationsInLidarAssetObject = (asset, configurations) => {
    const updatedAsset = deepCopyObject(asset);

    if (configurations.obstructionDisabledUntil) {
        updatedAsset.assetDetails.assetAttributes.obstructionDisabledUntil =
            chainWalk(() => JSON.stringify(configurations.obstructionDisabledUntil), "0")
    }
    return updatedAsset;
}


// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/datamodel/LidarAssetModelResource.js